module.exports = __webpack_public_path__ + "static/media/400048_02.cfd1d11d.png";